<template>
  <div class="profile-tile" v-if="files.length">
    <h3>Resources</h3>
    <hr>
    <!-- <h4 class="mb-3" v-if="user.status == 'Application Approved'">Step 1: Please read through the Family Welcome Pack</h4> -->
    <div class="row">
      <!-- <div class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Family Welcome Pack</h5>
          <a style="color: var(--fourosixdark)" href="https://s3.us-east-2.amazonaws.com/pinknannies.enginehire.io/documents/FTFamilyWelcomePacket+PN_+(3).pdf" target="_blank">View</a>
        </div>
      </div> -->

      <!-- <div class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">TD1 Federal</h5>
          <a style="color: var(--fourosixdark)" href="https://s3.ca-central-1.amazonaws.com/thenannycompany.enginehire.io/documents/td1-Federal-2020.pdf" target="_blank">View</a>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">TD1 Provincial</h5>
          <a style="color: var(--fourosixdark)" href="https://s3.ca-central-1.amazonaws.com/thenannycompany.enginehire.io/documents/td1-+Provincial-2020.pdf" target="_blank">View</a>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Payroll Schedule</h5>
          <a style="color: var(--fourosixdark)" href="https://s3.ca-central-1.amazonaws.com/thenannycompany.enginehire.io/documents/2020+Payroll+Schedule.pdf" target="_blank">View</a>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Employee Handbook</h5>
          <a style="color: var(--fourosixdark)" href="https://s3.ca-central-1.amazonaws.com/thenannycompany.enginehire.io/documents/TNCI+Employee+Handbook.docx" target="_blank">View</a>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Reimbursement Form</h5>
          <a style="color: var(--fourosixdark)" href="https://s3.ca-central-1.amazonaws.com/thenannycompany.enginehire.io/documents/Monthly+KM+-+Nanny.pdf" target="_blank">View</a>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Interview Tips</h5>
          <a style="color: var(--fourosixdark)" href="https://s3.ca-central-1.amazonaws.com/thenannycompany.enginehire.io/documents/NANNY+INTERVIEW+TIPS.docx" target="_blank">View</a>
        </div>
      </div> -->

      <div v-for="file in files" :key="file.id" class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">{{ file.name }}</h5>
          <a style="" :href="file.file_link" target="_blank"><button class="mylisting-button dark-button">View</button></a>
        </div>
      </div>
    </div>
    <!-- <hr>
    <h4>Guide:</h4>
    <p>Please download the Payroll Details, TD1 Federal and TD1 Provincial forms by clicking the "View" links. Once you download them you can either print them out and fill them in, or fill them in electronically using Adobe Acrobat Reader (which you can download for free here: https://get.adobe.com/reader/, here is a guide on how to fill forms: https://helpx.adobe.com/ca/acrobat/using/filling-pdf-forms.html, basically open the document with Adobe Reader and then click the "Fill & Sign" tool button). Once you have finished filling in the documents, please upload them in the section above!</p> -->
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      files: [],
    }
  },
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    // viewOnlyAccess() {
    //   if (this.$store.getters.isEmployer === true) {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    },
  },
  created() {
    this.getFiles()
  },
  methods: {
    getFiles() {
      // axios.get(`/api/files/?selector1=Resource&selector2=Candidate`)
      //   .then(res => {
      //     this.candidateFiles = res.data
      //   })
      //   .catch(error => console.log(error))

      axios.get(`/api/files/?agency=${this.$store.getters.agencyID}&selector1=Resource&selector2=Employer`)
        .then(res => {
          this.files = res.data
        })
        .catch(error => console.log(error))
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/Resources.vue